import React from 'react';
import styled from 'styled-components';
import { theme } from '../styled/theme';
import { Container, Hxl, Flex, ButtonLinkPrimary, ButtonLink } from '../styled/BaseComponents';

const HeroWrapper = styled.section`
  padding-top: 6rem;
  padding-bottom: 1.5rem;
  text-align: center;
  transform: translateY(var(--custodiy-heroY));
  opacity: var(--custodiy-heroOpacity);
  transition: transform 0.2s ease, opacity 0.2s ease;
  
  @media (max-width: ${theme.breakpoints.md}) {
    padding-top: 5rem;
  }
`;

const HeroSubtitle = styled.h2`
  font-size: clamp(1rem, 1.5vw + 0.5rem, 1.25rem);
  font-weight: 500;
  background: linear-gradient(90deg, ${theme.colors.accent}, ${theme.colors.accent2}, ${theme.colors.white});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  margin: 0 0 1.5rem 0;
  letter-spacing: 0.02em;
  padding-top: 0.5rem;
`;

const HeroTitle = styled(Hxl)`
  background: linear-gradient(90deg, ${theme.colors.accent}, ${theme.colors.accent2}, ${theme.colors.white});
  -webkit-background-clip: text;
  color: transparent;
`;

const HeroActions = styled(Flex)`
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

export const Hero = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const isLoggedIn = user && user.token;

  return (
    <HeroWrapper>
      <Container>
        {/* <HeroSubtitle>AI & Blockchain Infrastructure for the Pharmaceutical Supply Chain</HeroSubtitle> */}
        <HeroTitle>AI & Blockchain Infrastructure for the Pharmaceutical Supply Chain</HeroTitle>

        {!isLoggedIn && (
          <HeroActions gap="0.75rem">
            <ButtonLinkPrimary to="/sign-in">Get started</ButtonLinkPrimary>
            <ButtonLink to="/sign-up">Create account</ButtonLink>
          </HeroActions>
        )}
      </Container>
    </HeroWrapper>
  );
};

export default Hero;

